import { COLORS } from "../../../utils/colors"


export const useChatStyles = () => {
    return {
        resetReport: {
            marginLeft: 'auto',
            textTransform: 'capitalize',
            textDecoration: 'underline',
            color: COLORS.RED,
            fontSize: '12px'
          },
          chatPanel: {
            padding: '1rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            overflowY: 'auto',
            height: 'calc(100vh - 5.8rem)',
            marginTop: '-1px',
            backgroundColor: 'white',
            borderTop: `1px solid #ebebeb`,
          },
          chatBox: {
            padding: '1rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            overflowY: 'auto',
            height: 'calc(100vh - 5.8rem)',
            marginTop: '-1px',
            backgroundColor: 'white',
          },
          enterMessage: {
            borderTop: `1px solid ${COLORS.LIGHT_GRAY}`,
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            bgcolor: COLORS.WHITE,
            px: '.75rem',
            '& .MuiInput-input': {
              height: '2.5rem',
              outline: 'none',
            },
            '& .MuiInput-root:before': {
              outline: 'none',
              border: 'none',
            },
          },
    }
}
